import React from 'react'
import './note-area.css'
import Note from './Note/Note'

const NoteArea = (props) => {
    React.useEffect(() => {
        setTimeout(() => {
            document.getElementById('note-area-wrapper').style.opacity = 1
            document.getElementById('note-area-wrapper').style.right = '5px'
        }, 100)
    }, [])

    return(
        <div className='note-area-wrapper' id='note-area-wrapper'>
            <div className='note-area__add-note-btn' onClick={() => props.createNoteFunc()}>+ Add Event</div>
            {props.sideBarNotes.map((note) => <Note key={note.id} note={note} userData={props.userData} setEditNote={props.setEditNote} />)}
        </div>
    )
}
export default NoteArea